import { ApolloLink } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import useMultiRegionStore from "./multiRegionMiddleware/stores/useMultiRegionStore";

const loggingMiddleware = new ApolloLink((operation, forward) => {
	let t = performance.now();
	return forward(operation).map((response) => {
		const definition = getMainDefinition(operation.query);
		if (definition.kind === "OperationDefinition" && definition.operation !== "subscription") {
			let diff = Math.round(performance.now() - t);
			if (__DEV__) {
				const pinBehavior = operation.getContext().pinBehavior;
				console.info({
					duration: diff,
					api:
						pinBehavior === "long"
							? "Primary (Long)"
							: useMultiRegionStore.getState().checkIsPinned() ||
								  pinBehavior === "inert"
								? "Primary"
								: "Satellite",
					msg: `${operation.operationName} completed`,
				});
			}
		}
		return response;
	});
});

export default loggingMiddleware;
